import { useNavigate } from 'react-router';

import { generateWorkflowPath } from '~/core/application/routing/generateWorkflowPath';
import { useFetchWorkflow } from '../../../api/workflows/hooks';
import { useEventHandler } from '../../useEventHandler';
import { useRootDocumentOrFail } from '../../useRootDocumentOrFail';

export const useSwitchToWorkflow = () => {
  const rootDocument = useRootDocumentOrFail();
  const { fetchWorkflow } = useFetchWorkflow(rootDocument.definition);
  const navigate = useNavigate();

  return useEventHandler(
    async (workflowName: string, currentPlace?: string): Promise<boolean> => {
      try {
        const workflow = await fetchWorkflow(workflowName);
        navigate(
          generateWorkflowPath(
            rootDocument.shortId,
            workflow.name,
            currentPlace,
          ),
        );
      } catch {
        return false;
      }
      return true;
    },
  );
};
